<template>
<div id="app">
    <form enctype="multipart/form-data" novalidate id="myForm">
<div v-if="start==true">
  <b-container fluid>
                <b-row>
                    <b-col cols="12">
                        <img alt="Notts Police Logo" src="./assets/notts-police-logo.png">
                        

                    </b-col>
                </b-row>
 <b-card class="npfheadercard mt-2" title="Submitting dash cam footage" >

   <b-alert variant="primary" show>
                        <font-awesome-icon :icon="['fas', 'exclamation-triangle']"></font-awesome-icon>&nbsp;&nbsp;If you wish to submit dash cam footage to the police please be aware that you will need to follow this guidance:
                    </b-alert>



<p class="text-muted pt-1">There are two ways to submit dashcam / helmet camera footage - if you are able to upload your footage please fill in our online form.</p>
<p class="text-muted pt-1">This service has been produced with the support of the <a href="https://www.gov.uk/government/organisations/department-for-transport">Department for Transport</a></p>
<p class="text-muted pt-1">If you are unable to upload your dashcam / helmet camera footage then please follow these steps:</p>
<ul class="text-muted pt-1">
<li>Report the incident on 101</li>
<li>Please be aware that we will need the whole, unedited footage of your journey, not just the incident.</li>
<li>Footage will need to be either on a SD card, memory stick, or CD. We cannot accept edited clips or footage from social media.</li>
<li>Please be aware that the driving or riding of all parties will be reviewed when the footage is submitted as will the interactions between the parties.</li>
<li>We may require you to give a written statement to evidence the footage.</li>
<li>You may be required to attend court as a witness.</li>
</ul>
 <b-button class="m-3" size="lg" v-on:click="openFAQ" variant="info">
                            <font-awesome-icon :icon="['fas', 'info-circle']"></font-awesome-icon>&nbsp;&nbsp;Dash or helmet camera FAQ's and Termas and Conditions
                        </b-button>

 <b-button class="m-3" size="lg" v-on:click="startform" variant="primary">
                            <font-awesome-icon :icon="['fas', 'pen-alt']"></font-awesome-icon>&nbsp;&nbsp;Complete Online form
                        </b-button>

</b-card>
  </b-container>
</div>


        <div v-if="loading==false && submitted == false && start==false">

            <b-container fluid>
                <b-row>
                    <b-col cols="12">
                        <img alt="Notts Police Logo" src="./assets/notts-police-logo.png">

                        <!-- <datetime v-model="vm.LocationOfIncident.DateTimeOfIncident"></datetime> -->

                        <!-- <date-picker class="vue-picker1" name="picker1" :config="options" v-model="vm.LocationOfIncident.DateTimeOfIncident">
                                                            </date-picker> -->

                    </b-col>
                </b-row>
                <br>

                <b-card class="npfheadercard" title="Nottinghamshire Police Dashcam Footage Upload" sub-title="Could you please complete all sections of the below form and submit your footage. Please note this system is only for the use of reporting road traffic incidents caught on camera. This is not for road traffic accidents or any other crime, unless specifically requested by an officer or media campaign. Nottinghamshire Police will take appropriate action after viewing the uploaded footage. We will not contact you unless we require further information.">

                    <br>
                    <b-alert variant="primary" show>
                        <font-awesome-icon :icon="['fas', 'exclamation-triangle']"></font-awesome-icon>&nbsp;&nbsp;Please remember your original copies remain the original evidence and may be required in court. You must keep the original copies of any video or photographs you submit to us for two years.
                    </b-alert>

                    <b-alert variant="success" show>
                        <font-awesome-icon :icon="['fas', 'car-side']"></font-awesome-icon>&nbsp;&nbsp;This service has been produced with the support of the Department for Transport
                    </b-alert>
                    <br>
                    <b-row>
                        <b-col cols="12">

                            <input class="npfcheckbox" type="checkbox" v-on:click="attendCourt(true)" v-model="vm.willingToGotToCourt">&nbsp;&nbsp; <span>I <b><u>am</u></b> willing to attend court and give evidence in relation to this matter</span>

                        </b-col>
                    </b-row>
                    <b-row style="padding-top:20px;">
                        <b-col cols="12">

                            <input class="npfcheckbox" type="checkbox" v-on:click="attendCourt(false)" v-model="vm.notwillingToGotToCourt">&nbsp;&nbsp; <span>I am <b><u>not</u></b> willing to attend court and give evidence in relation to this matter </span>

                        </b-col>
                    </b-row>
                    <b-row style="padding-top:20px;" v-if="vm.notwillingToGotToCourt == true">
                        <b-col cols="12">

                            <b-alert variant="warning" show>
                                <font-awesome-icon :icon="['fas', 'exclamation-triangle']"></font-awesome-icon>&nbsp;&nbsp;As you are unable to attend Court and provide evidence of the offence you wish to report, it is unlikely that Nottinghamshire Police will be able to proceed with this matter.
                            </b-alert>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row>
                        <b-col cols="12">
                            <b-alert variant="primary" show>
                                <font-awesome-icon :icon="['fas', 'external-link-alt']"></font-awesome-icon>&nbsp;&nbsp;
                                <a target="_blank" href="./DashCamFAQ.pdf">Nottinghamshire Police FAQ and Terms and Conditions in relation to Dash and helmet cameras</a>
                            </b-alert>
                        </b-col>
                    </b-row>

                    <b-row style="padding-top:20px;">
                        <b-col cols="12" v-if="vm.aceptTandC == false">
                            <b-alert variant="warning" show>
                                <font-awesome-icon style="font-size:200%;" :icon="['fas', 'hand-point-right']"></font-awesome-icon>&nbsp;&nbsp;<input class="npfcheckbox" type="checkbox" v-model="vm.aceptTandC">&nbsp;&nbsp; <span>I have read and agreed with the above FAQ and the terms and conditions?</span>
                            </b-alert>
                        </b-col>
                        <b-col v-if="vm.aceptTandC == true" cols="12">
                            <b-alert variant="success" show>
                                <font-awesome-icon style="font-size:200%;" :icon="['fas', 'thumbs-up']"></font-awesome-icon>&nbsp;&nbsp;<input class="npfcheckbox" type="checkbox" v-model="vm.aceptTandC">&nbsp;&nbsp; <span>I have read and agreed with the above FAQ and the terms and conditions?</span>
                            </b-alert>
                        </b-col>
                    </b-row>
                </b-card>
                <br>
                <div v-if="vm.aceptTandC == true">
                    <b-card class="npfheadercard" title="Your details" sub-title="We require your details so that we can log this incident">
                        <b-row>
                            <b-col cols="6">
                                <b-form-group id="input-group-1" label="Forename:">
                                    <b-form-input v-model="vm.yourdata.firstname" required placeholder="forename"></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group id="input-group-1" label="Surname:">
                                    <b-form-input v-model="vm.yourdata.surname" required placeholder="surname"></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="Address line 1:">
                                    <b-form-input v-model="vm.yourdata.address1" required placeholder=""></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="Address line 2:">
                                    <b-form-input v-model="vm.yourdata.address2" required placeholder=""></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="Town:">
                                    <b-form-input v-model="vm.yourdata.town" required placeholder=""></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="County:">
                                    <b-form-input v-model="vm.yourdata.county" required placeholder=""></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="Post Code:">
                                    <b-form-input v-model="vm.yourdata.postcode" required placeholder=""></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="Date of Birth:">
                                    <b-form-input v-model="vm.yourdata.dateofbirth" required placeholder=""></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="Email address:">
                                    <b-form-input v-model="vm.yourdata.email" required type="email" placeholder=""></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="Title:">
                                    <b-form-input v-model="vm.yourdata.title" required placeholder="e.g. Mr or Mrs"></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="Phone number:">
                                    <b-form-input v-model="vm.yourdata.phone" required placeholder=""></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="Mobile number:">
                                    <b-form-input v-model="vm.yourdata.mobile" required placeholder=""></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>

                    </b-card>
                    <br>
                    <b-card class="npfheadercard" title="Your Vehicle" sub-title="We require details about your vehicle">

                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="Make:">
                                    <b-form-input v-model="vm.vicvehicle.Make" placeholder="e.g. Ford"></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="Model:">
                                    <b-form-input v-model="vm.vicvehicle.Model" placeholder="eg. Ka"></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="Registration:">
                                    <b-form-input v-model="vm.vicvehicle.Vrm" placeholder="e.g. AB12 XYZ"></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="Colour:">
                                    <b-form-input v-model="vm.vicvehicle.Colour" placeholder="e.g. Blue"></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="You are the ....:">

                                    <b-form-select v-model="vm.vicvehicle.YouAreThe" :options="VehicleYouAre"></b-form-select>

                                </b-form-group>
                            </b-col>

                        </b-row>

                        <br>

                    </b-card>
                    <br>
                    <b-card class="npfheadercard" title="Offending Vehicle" sub-title="We require details about the offending vehicle">

                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="Make:">
                                    <b-form-input v-model="vm.vehicle.Make" placeholder="e.g. Ford"></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="Model:">
                                    <b-form-input v-model="vm.vehicle.Model" placeholder="eg. Ka"></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="Registration:">
                                    <b-form-input v-model="vm.vehicle.Vrm" placeholder="e.g. AB12 XYZ"></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="Colour:">
                                    <b-form-input v-model="vm.vehicle.Colour" placeholder="e.g. Blue"></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="Was the offending vehicle displaying 'L' Plates?:">
                                    <input class="npfcheckbox" type="checkbox" v-model="vm.vehicle.OffendingVehicleDisplayingLPlates">

                                </b-form-group>
                            </b-col>

                        </b-row>

                        <br>

                    </b-card>
                    <br>
                    <b-card class="npfheadercard" title="Location of Incident" sub-title="We require details about the location of the incident and the weather conditions at the time">

                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="Road Name or Number:">
                                    <b-form-input v-model="vm.LocationOfIncident.RoadName" placeholder="e.g. A60"></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="Day Of Incident:">

                                    <b-form-input v-model="vm.LocationOfIncident.Day" placeholder="e.g. Monday"></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="Date Incident:">
                                    <date-picker class="vue-picker1" name="picker1" :config="options" v-model="vm.LocationOfIncident.DateIncident">
                                    </date-picker>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="Time Of Incident:">

                                    <date-picker class="vue-picker1" name="picker1" :config="options2" v-model="vm.LocationOfIncident.TimeIncident">
                                    </date-picker>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="City / Town / Village:">
                                    <b-form-textarea id="textarea" v-model="vm.LocationOfIncident.CityTownVillage" placeholder="Please tell us the city or town or village that the incident happened..." rows="3" max-rows="15"></b-form-textarea>

                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="You were travelling away from?:">
                                    <b-form-textarea id="textarea" v-model="vm.LocationOfIncident.YouWereTravellingAwayFrom" placeholder="Please tell us where you were travelling from when the incident happened..." rows="3" max-rows="15"></b-form-textarea>

                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="You were travelling towards?:">
                                    <b-form-textarea id="textarea" v-model="vm.LocationOfIncident.YouWereTravellingTowards" placeholder="Please tell us where you were travelling towards when the incident happened..." rows="3" max-rows="15"></b-form-textarea>

                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="The offending vehicle was travelling away from?:">
                                    <b-form-textarea id="textarea" v-model="vm.LocationOfIncident.Theoffendingvehiclewasdrivingawayfrom" placeholder="Please tell us where the offending vehicle was travelling from when the incident happened..." rows="3" max-rows="15"></b-form-textarea>

                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="The offending vehicle was travelling towards?:">
                                    <b-form-textarea id="textarea" v-model="vm.LocationOfIncident.Theoffendingvehiclewasdrivingtowards" placeholder="Please tell us where the offending vehicle was travelling towards when the incident happened..." rows="3" max-rows="15"></b-form-textarea>

                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="The Weather Conditions at the time were ....:">

                                    <b-form-select v-model="vm.LocationOfIncident.WeatherConditions" :options="WeatherConditions"></b-form-select>

                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <b-form-group label="The Road Conditions at the time were ....:">

                                    <b-form-select v-model="vm.LocationOfIncident.TheRoadConditions" :options="RoadConditions"></b-form-select>

                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="The Lighting Conditions at the time were ....:">

                                    <b-form-select v-model="vm.LocationOfIncident.TheLightingConditions" :options="LightingConditions"></b-form-select>

                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="Any Other relevant Location Information:">
                                    <b-form-textarea id="textarea" v-model="vm.LocationOfIncident.AnyOtherRelevantLocationDetails" placeholder="Please tell if there is any other identifiable information to help us locate the exact location of the incident..." rows="8" max-rows="15"></b-form-textarea>

                                </b-form-group>
                            </b-col>

                        </b-row>

                        <br>

                    </b-card>
                    <br>
                    <b-card class="npfheadercard" title="Statement" sub-title="We require your statement, your account of what happened">
                        <b-alert variant="primary" show>
                            <font-awesome-icon :icon="['fas', 'exclamation-triangle']"></font-awesome-icon>&nbsp;&nbsp;<b>PLEASE NOTE : </b>This portal deals with traffic offences, it is <b><u>NOT</u></b> for submitting footage of RTC's or public order offences, any reports of parking offences should be referred
                            to the relevant highway authority in the locality where it occurred.
                        </b-alert>

                        <b-form-textarea id="textarea" v-model="vm.details" placeholder="In as much detail as you can, please tell us what happened - i.e. I was driving my car along London Road, travelling towards Nottingham City Centre from Trent Bridge, and was just passing the Fire Station to the left when I saw the offending vehicle in the junction to my left ahead of me.  This vehicle then pulled out across the road in front of me causing me to brake sharply and I thought I was going to have a collision.  The offending vehicle then joined the carriageway and drove off towards Trent Bridge." rows="8" max-rows="15"></b-form-textarea>

                        <br>

                        <b-row style="padding-top:20px;">
                            <b-col cols="12" v-if="vm.statementcorrect == false">
                                <b-alert variant="warning" show>
                                    <font-awesome-icon style="font-size:200%;" :icon="['fas', 'hand-point-right']"></font-awesome-icon>&nbsp;&nbsp;<input class="npfcheckbox" type="checkbox" v-model="vm.statementcorrect">&nbsp;&nbsp; <span>I confirm this statement is true to the best of my knowledge and belief and I make it knowing that if it is tendered in evidence I shall be liable to prosecution if I have wilfully stated in it anything which I know to be false, or do not believe to be true.</span>
                                </b-alert>
                            </b-col>
                            <b-col v-if="vm.statementcorrect == true" cols="12">
                                <b-alert variant="success" show>
                                    <font-awesome-icon style="font-size:200%;" :icon="['fas', 'thumbs-up']"></font-awesome-icon>&nbsp;&nbsp;<input class="npfcheckbox" type="checkbox" v-model="vm.statementcorrect">&nbsp;&nbsp; <span>I confirm this statement is true to the best of my knowledge and belief and I make it knowing that if it is tendered in evidence I shall be liable to prosecution if I have wilfully stated in it anything which I know to be false, or do not believe to be true.</span>
                                </b-alert>
                            </b-col>
                        </b-row>
                        <b-row v-if="vm.statementcorrect == true" style="padding-top:20px;">
                            <b-col cols="6">

                                <b-form-group label="Signed (full Name):">
                                    <b-form-input v-model="vm.signed"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">

                                <b-form-group label="Date and Time:">
                                    <date-picker class="vue-picker1" name="picker2" :config="optionsdt" v-model="vm.dateTimeOfSignaure"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-card>
                    <br>
                    <b-card class="npfheadercard" title="Upload your supporting files" sub-title="File upload">

                        <b-alert variant="primary" show>
                            <font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon>&nbsp;&nbsp;<b>DO NOT </b>alter the footage before uploading, this includes adding voice overs or adding inline comments.
                            <br>
                            <font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon>&nbsp;&nbsp;Footage uploaded <b>MUST</b> be raw original footage, with <b>NO EDITING</b> of any kind.
                            <br>
                            <font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon>&nbsp;&nbsp;<b>DO NOT </b>post the footage on social media – if you have done so, please remove it.
                            <br>
                            <font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon>&nbsp;&nbsp;<b>DO NOT </b>delete the footage from your device.
                            <br>

                            <font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon>&nbsp;&nbsp;Video <b>Must </b>be in one of the following formats mp4, .wmv, .mpg, .mov, .avi.
                            <br>
                            <font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon>&nbsp;&nbsp;Video <b>Must </b> be uniquely named.
                            <br>
                            <font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon>&nbsp;&nbsp;<b>Maximum </b>of four videos.
                            <br>
                            <font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon>&nbsp;&nbsp;<b>Maximum </b>size of 500 MB per file.
                            <br>

                        </b-alert>

                        <br>

                        <b-alert show variant="warning">
                            <font-awesome-icon :icon="['fas', 'exclamation-triangle']"></font-awesome-icon>&nbsp;&nbsp;Please be aware that your device may have recorded you and that the actions of all parties will be reviewed and action taken as appropriate.
                        </b-alert>
                        <b-row style="padding-top:20px;">
                            <b-col cols="12" v-if="vm.IsYourtimeAndDateOnfootageAccurate == false">
                                <b-alert variant="warning" show>
                                    <font-awesome-icon style="font-size:200%;" :icon="['fas', 'hand-point-down']"></font-awesome-icon>&nbsp;&nbsp;<input class="npfcheckbox" type="checkbox" v-model="vm.IsYourtimeAndDateOnfootageAccurate">&nbsp;&nbsp; <span>Is your time and date on your footage accurate?</span>
                                </b-alert>
                            </b-col>
                            <b-col v-if="vm.IsYourtimeAndDateOnfootageAccurate == true" cols="12">
                                <b-alert variant="success" show>
                                    <font-awesome-icon style="font-size:200%;" :icon="['fas', 'thumbs-up']"></font-awesome-icon>&nbsp;&nbsp;<input class="npfcheckbox" type="checkbox" v-model="vm.IsYourtimeAndDateOnfootageAccurate">&nbsp;&nbsp; <span>Is your time and date on your footage accurate?</span>
                                </b-alert>
                            </b-col>
                        </b-row>

                        <b-row v-if="vm.IsYourtimeAndDateOnfootageAccurate == false" style="padding-top:20px;">
                            <b-col cols="12">
                                <b-form-group label="Please give details of how far out the time and date in your footage is compared with the actual time:">
                                    <b-form-textarea id="textarea" v-model="vm.IfNotHowFarOutTime" placeholder="Please give details of how far out the time and date in your footage is compared with the actual time..." rows="3" max-rows="15"></b-form-textarea>

                                </b-form-group>
                            </b-col>

                        </b-row>

                        <div class="fileUpload btn btn-primary" v-if="files.length ==0">
                            <font-awesome-icon :icon="['fas', 'video']"></font-awesome-icon>&nbsp;&nbsp;
                            <span>Upload </span> &nbsp;&nbsp;
                            <font-awesome-icon :icon="['fas', 'upload']"></font-awesome-icon>
                            <input type="file" class="upload" accept=".mp4,.wmv,.mpg,.mov,.avi" id="fileUpload1" @change="onFileChange">
                        </div>
                        <div class="fileUpload btn btn-primary" v-if="files.length ==1">
                            <font-awesome-icon :icon="['fas', 'video']"></font-awesome-icon>&nbsp;&nbsp;
                            <span>Upload </span> &nbsp;&nbsp;
                            <font-awesome-icon :icon="['fas', 'upload']"></font-awesome-icon>
                            <input type="file" class="upload" accept=".mp4,.wmv,.mpg,.mov,.avi" id="fileUpload2" @change="onFileChange">
                        </div>
                        <div class="fileUpload btn btn-primary" v-if="files.length ==2">
                            <font-awesome-icon :icon="['fas', 'video']"></font-awesome-icon>&nbsp;&nbsp;
                            <span>Upload </span> &nbsp;&nbsp;
                            <font-awesome-icon :icon="['fas', 'upload']"></font-awesome-icon>
                            <input type="file" class="upload" accept=".mp4,.wmv,.mpg,.mov,.avi" id="fileUpload3" @change="onFileChange">
                        </div>
                        <div class="fileUpload btn btn-primary" v-if="files.length ==3">
                            <font-awesome-icon :icon="['fas', 'video']"></font-awesome-icon>&nbsp;&nbsp;
                            <span>Upload </span> &nbsp;&nbsp;
                            <font-awesome-icon :icon="['fas', 'upload']"></font-awesome-icon>
                            <input type="file" class="upload" accept=".mp4,.wmv,.mpg,.mov,.avi" id="fileUpload4" @change="onFileChange">
                        </div>
                        <!-- <div v-if="vm.files.length >0">  -->
                        <b-row>

                            <b-col v-for="(item, index) in files" v-bind:key="item.name" cols="6">

                                <b-card class="npfvideocard">
                                    <span><b>Video {{index+1}}</b></span>
                                    <br>
                                    <span><b>File Name:</b> {{item.name}}</span>
                                    <br>
                                    <video width="300" height="300" controls>
                                        <source v-bind:src="item.url" v-bind:type="item.type">

                                        Your browser does not support the video tag.
                                    </video>

                                    <!-- <button class="btn btn-danger" v-on:click="deletevideo(index)"><font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>&nbsp;&nbsp;Delete</button> -->
                                </b-card>
                            </b-col>

                        </b-row>

                        <b-row>
                            <b-col cols="12">
                                <b-alert variant="primary" show>
                                    <font-awesome-icon :icon="['fas', 'external-link-alt']"></font-awesome-icon>&nbsp;&nbsp;
                                    <a target="_blank" href="./NottsPrivacy_Notice_25.05.2018.pdf">Nottinghamshire Police Privacy Notice</a>
                                </b-alert>
                            </b-col>
                        </b-row>

                        <br>
                        <br>
                        <b-button size="lg" v-on:click="submitform" variant="success">
                            <font-awesome-icon :icon="['fas', 'paper-plane']"></font-awesome-icon>&nbsp;&nbsp;Submit
                        </b-button>

                    </b-card>

                    <br>
                </div>
                <div>
                    Submission ID: {{vm.uniqueID}}
                </div>

            </b-container>

        </div>
        <div v-if="loading==true && submitted == false">
            <b-row>
                <b-col cols="12">
                    <div class="centrediv">
                        <h1>Submitting your video to Nottinghamshire Police......</h1>

                        <img alt="Loading gif" src="./assets/831.gif">
                    </div>
                </b-col>
            </b-row>

        </div>
        <div v-if="loading==false && submitted == true">
            <div class="centrediv">
                <h1>Submitted To Notts Police!! </h1>
                <br>
                <p>If you need to contact Nottinghamshire Police please use your Submission ID: <b> {{vm.uniqueID}}</b></p>
            </div>
        </div>
    </form>
</div>
</template>

<script>
import {
    uuid
} from 'vue-uuid' // Import uuid

const CryptoJS = require("crypto-js");
const cyrtokeyClient = "JaNdRfUjXn2r5u8x/A?D(G+KbPeShVkY";

window.axios = require('axios');
import datePicker from 'vue-bootstrap-datetimepicker';
import {
    isIP
} from 'net';

export default {
    name: "app",
    components: {
        datePicker
    },
    data() {
        return {
            vm: {
                uniqueID: uuid.v1(),
                willingToGotToCourt: "",
                notwillingToGotToCourt: "",
                IsYourtimeAndDateOnfootageAccurate: true,
                IfNotHowFarOutTime: "",
                aceptTandC: false,
                yourdata: {
                    firstname: "",
                    surname: "",
                    address1: "",
                    address2: "",
                    town: "",
                    county: "",
                    postcode: "",
                    email: "",
                    phone: "",
                    dateofbirth: "",
                    mobile: "",
                    title: ""
                },
                vehicle: {
                    Vrm: "",
                    Make: "",
                    Model: "",
                    Colour: "",
                    OffendingVehicleDisplayingLPlates: false
                },
                vicvehicle: {
                    Vrm: "",
                    Make: "",
                    Model: "",
                    Colour: "",
                    YouAreThe: ""
                },
                LocationOfIncident: {
                    RoadName: "",
                    DateIncident: "",
                    TimeIncident: "",
                    Day: "",
                    CityTownVillage: "",
                    YouWereTravellingAwayFrom: "",
                    YouWereTravellingTowards: "",
                    Theoffendingvehiclewasdrivingawayfrom: "",
                    Theoffendingvehiclewasdrivingtowards: "",
                    AnyOtherRelevantLocationDetails: "",
                    WeatherConditions: "",
                    TheRoadConditions: "",
                    TheLightingConditions: "",

                },
                details: "",
                fileLinks: [],
                statementcorrect: false,
                signed: "",
                dateTimeOfSignaure: "",
            },
            start:true,
            loading: false,
            submitted: false,
            files: [],
            uploadedFiles: [],
            VehicleYouAre: ["Vehicle Driver", "Vehicle Front Seat passenger", "Vehicle Rear Seat passenger", "Motorcyclist", "Cyclist", "Horse Rider", "Pedestrian"],
            WeatherConditions: ["Fine without high winds", "Raining without high winds", "Snowing without high winds", "Fine with high winds", "Raining with high winds", "Snowing with high winds", "Fog or Mist", "Other"],
            RoadConditions: ["Dry", "Wet / Damp", "Snow", "Frost / Ice", "Flood (over 3cm deep)", "Other"],
            LightingConditions: ["Daylight", "Darkness with street lamps lit", "Darkness with street lamps present but unlit", "Darkness with no street lamps", "Darkness: street lamps unknown"],
            SignedUrlEndpoint: "https://78z1prsugd.execute-api.eu-west-2.amazonaws.com/prod/dashcamsignedurlfunction",
            image: '',
            options: {
                format: 'DD/MM/YYYY',
                useCurrent: true,
                sideBySide: false,
                showTodayButton: true,
                icons: {

                    time: 'far fa-clock',
                    date: 'far fa-calendar',
                    up: 'fas fa-arrow-up',
                    down: 'fas fa-arrow-down',
                    previous: 'fas fa-chevron-left',
                    next: 'fas fa-chevron-right',
                    today: 'fas fa-calendar-check',
                    clear: 'far fa-trash-alt',
                    close: 'far fa-times-circle'

                },
                showClear: true,
                showClose: true,
            },
            options2: {
                format: 'HH:mm',
                useCurrent: true,
                sideBySide: false,
                showTodayButton: true,
                icons: {

                    time: 'far fa-clock',
                    date: 'far fa-calendar',
                    up: 'fas fa-arrow-up',
                    down: 'fas fa-arrow-down',
                    previous: 'fas fa-chevron-left',
                    next: 'fas fa-chevron-right',
                    today: 'fas fa-calendar-check',
                    clear: 'far fa-trash-alt',
                    close: 'far fa-times-circle'

                },
                showClear: true,
                showClose: true,
            },
            optionsdt: {
                format: 'DD/MM/YYYY HH:mm',
                useCurrent: true,
                sideBySide: true,
                showTodayButton: true,
                icons: {

                    time: 'far fa-clock',
                    date: 'far fa-calendar',
                    up: 'fas fa-arrow-up',
                    down: 'fas fa-arrow-down',
                    previous: 'fas fa-chevron-left',
                    next: 'fas fa-chevron-right',
                    today: 'fas fa-calendar-check',
                    clear: 'far fa-trash-alt',
                    close: 'far fa-times-circle'

                },
                showClear: true,
                showClose: true,
            }

        }
    },
    methods: {
        handleFileUploads() {

        },
        deletevideo() {

        },
        attendCourt(val) {
            if (val == true) {
                this.vm.willingToGotToCourt = true;
                this.vm.notwillingToGotToCourt = false;
            } else {
                this.vm.willingToGotToCourt = false;
                this.vm.notwillingToGotToCourt = true;
            }

        },
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            //console.log(files[0].size)

            //  if (files[0].size > 100940219) {

            if (files[0].size > 500940219) {

                this.$swal("File is too big!", "This File is too large to upload via this portal", "error")

                e.value = "";
                return;
            }
            var fileType = files[0].type;

            console.log(fileType)
            if (fileType != "video/mp4" && fileType != "video/mpg" && fileType != "video/wmv" && fileType != "video/mov" && fileType != "video/quicktime" && fileType != "video/avi") {

                this.$swal("File Type Not supported!", "This File type is not supported via this portal", "error")

                e.target.files = null;
                return;
            }

            this.UploadFile(files[0]);

        },
        UploadFile(file) {
            if (file == null) {
                return;
            }
            // var image = new Image();
            var reader = new FileReader();
            //var vm = this;

            var video = {
                name: file.name,
                url: "",
                type: file.type,
                filebuffer: null,
                file: file
            };

            reader.onload = (e) => {

                video.url = e.target.result;
                this.files.push(video);

            };
            reader.readAsDataURL(file);
            //console.log(video);

        },

        vsuccess(file, response) {

            this.$swal("Sorry", file.name, "warning");

            this.$swal("Sorry", response.url, "warning");

        },
        getSignedUrlPromise(fileName, fileType) {

            var urlsigne = this.SignedUrlEndpoint + "?name=" + fileName + "&type=" + fileType;

            //console.log(this.SignedUrlEndpoint);

            //console.log(urlsigne);

            //var cleanedUp = encodeURI(urlsigne);
            //console.log(cleanedUp);

            // return  new Promise(function(resolve, reject) {
            //    this.axios.get(urlsigne)
            //         .then(function(response) {

            //             resolve(response.data.url)

            //         })
            //         .catch(function(error) {
            //             //console.log(error);
            //             //console.error(error)
            //             reject(error.statusText)
            //         });
            // });

            return new Promise((resolve, reject) => {
                this.axios.get(urlsigne)
                    .then(function (response) {

                        resolve(response.data.url)

                    })
                    .catch(function (error) {
                        // console.log(error);
                        // console.error(error)
                        reject(error.statusText)
                    });

            })

        },
        uploadFilePromise(url, file) {

            //console.log(file);

            //   return new Promise(function(resolve, reject) {
            //                 var options = {
            //                     headers: {
            //                         'Content-Type': file.type
            //                     }
            //                 };

            //                 axios.put(url, file, options).then(function() {
            //                         //console.log(response);
            //                         resolve()
            //                     })
            //                     .catch(function(error) {
            //                         //console.log(error);
            //                         reject(error.statusText)
            //                     }); 
            //             });

            return new Promise((resolve, reject) => {
                // console.log(file);
                // console.log(file.type);

                var options = {
                    headers: {
                        'Content-Type': file.type
                    }
                };

                axios.put(url, file, options).then(function (response) {
                        //console.log(response);
                        resolve()
                    })
                    .catch(function (error) {
                        // console.log(error);
                        reject(error.statusText)
                    });

            })

            //return promise

        },
        validateForm() {

            if (this.files != null && this.files.length < 1) {
                this.$swal("No Video!", "Please add a video", "error");
                return false;
            } else {
                var validationErrorsList = [];
                var validationError = false;


                if (this.vm.yourdata.firstname == "") {
                    validationErrorsList.push("Please add your Forename");
                    validationError = true;
                }
                if (this.vm.yourdata.surname == "") {
                    validationErrorsList.push("Please add your Surname");
                    validationError = true;
                }
                  if (this.vm.yourdata.dateofbirth == "") {
                    validationErrorsList.push("Please add your Date of birth");
                    validationError = true;
                }
   if (this.vm.yourdata.email == "") {
                    validationErrorsList.push("Please add your email address");
                    validationError = true;
                }
                   if (this.vm.yourdata.phone == "" && this.vm.yourdata.mobile == "") {
                    validationErrorsList.push("Please add either a phone number or mobile number");
                    validationError = true;
                }

       if (this.vm.vicvehicle.YouAreThe == "" ) {
                    validationErrorsList.push("Please specify a value from the 'You are the ...' drop down list");
                    validationError = true;
                }
                       if (this.vm.vehicle.Vrm == "" ) {
                    validationErrorsList.push("Please specify the offending Vehicle Registration");
                    validationError = true;
                }
         if (this.vm.LocationOfIncident.Day == "" ) {
                    validationErrorsList.push("Please specify the Day of incident");
                    validationError = true;
                }
 if (this.vm.LocationOfIncident.DateIncident == "" ) {
                    validationErrorsList.push("Please specify the Date of incident");
                    validationError = true;
                }
 if (this.vm.LocationOfIncident.TimeIncident == "" ) {
                    validationErrorsList.push("Please specify the Time of incident");
                    validationError = true;
                }
 if (this.vm.LocationOfIncident.CityTownVillage == "" ) {
                    validationErrorsList.push("Please specify the City/Town/Village the incident happended in");
                    validationError = true;
                }

                 if (this.vm.LocationOfIncident.WeatherConditions == "" ) {
                    validationErrorsList.push("Please specify the Weather conditions at the time");
                    validationError = true;
                }

                     if (this.vm.LocationOfIncident.TheRoadConditions == "" ) {
                    validationErrorsList.push("Please specify the Road conditions at the time");
                    validationError = true;
                }


                     if (this.vm.LocationOfIncident.TheLightingConditions == "" ) {
                    validationErrorsList.push("Please specify the Lighting conditions at the time");
                    validationError = true;
                }

      if (this.vm.details == "" ) {
                    validationErrorsList.push("Please write your statement");
                    validationError = true;
                }
                    if (this.vm.signed == "" ) {
                    validationErrorsList.push("Please Sign your statement");
                    validationError = true;
                }
       if (this.vm.dateTimeOfSignaure == "" ) {
                    validationErrorsList.push("Please Sign and Date your statement");
                    validationError = true;
                }

                if (validationError) {
                    var htmlerror = "<div style='text-align: left;'><ul>";
                    validationErrorsList.forEach(function (item) {
                        htmlerror += "<li>" + item + "</li>";
                    });
                    htmlerror += "</ul></div>";
                    window.scrollTo(0, 0);
                    this.$swal("Validation Error(s)", htmlerror, "error");

                    return false;
                } else {

                    return true;
                }

            }

            return true;
        },
        SendEmail() {

            //Only send email after all files are uploaded 
            console.log(this.uploadedFiles.length);
            console.log(this.files.length);

            var npfapp = this;
            var vmObject = JSON.stringify(this.vm);
            var UniqueID = this.vm.uniqueID;
            var onetimeKey = cyrtokeyClient + UniqueID.toString();

            var ciphertext = CryptoJS.AES.encrypt(vmObject, onetimeKey);
            if (this.uploadedFiles.length == this.files.length) {
                console.log("Started");

                axios.post('https://gqbea1d8mh.execute-api.eu-west-2.amazonaws.com/prod/sohnpf', {
                        "data": ciphertext.toString(),
                        "subject": "NPF DCFU - Submission ID:" + UniqueID.toString()
                    }, {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json',
                        }
                    })
                    .then(function () {

                        npfapp.loading = false;
                        npfapp.submitted = true;

                        npfapp.$swal("Submitted!!!", "This has been submited To Nottinghamshire Police", "success");

                    })
                    .catch(function (error) {

                        console.log(error);

                        npfapp.$swal("Not Submitted!!!", "There has been an error", "error");

                    });

            }

        },
        startform(){
this.start = false;
        },
        openFAQ(){
 window.open("./DashCamFAQ.pdf", 
                '_blank');
        },
        submitform() {

            if (this.validateForm()) {

                this.loading = true;

                var num = 1;

                //var error = false;
                //var submitted = false;

                this.files.forEach(element => {
                    var _file = element.file;
                    var filename = this.vm.uniqueID + "/Video" + num + "_" + _file.name.replace(/\s+/g, '');
                    var fullLink = "https://s3-eu-west-2.amazonaws.com/odcf.storage.npf/" + filename;
                    var filedetails = {
                        fileLink: fullLink,
                        fileName: _file.name,
                        fileType: _file.type
                    }

                    this.vm.fileLinks.push(filedetails);
                    //console.log(filedetails);

                    var _this = this;

                    this.getSignedUrlPromise(filename, _file.type)
                        .then((url) => this.uploadFilePromise(url, _file))
                        .then(() => {
                            //console.log('Donesddd');
                            _this.uploadedFiles.push("Done");
                            if (_this.uploadedFiles.length == _this.files.length) {
                                _this.SendEmail()
                            }

                        })
                        .catch((error) => {
                            console.log(error);

                            _this.$swal("Error", "There has been an error", "error")
                        })

                    num++;
                });

            }

        }
    },
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    margin-top: 10px;
}

.npfcheckbox {
    zoom: 2;
}

.npfheadercard {
    background-color: #f3eded !important;
}

.npfvideocard {
    background-color: #d4d4d4 !important;
    margin-top: 10px;
    margin-bottom: 10px;
}

.fileUpload {
    position: relative;
    overflow: hidden;
    margin: 10px;
}

.fileUpload input.upload {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    padding: 0;
    font-size: 20px;
    cursor: pointer;
    opacity: 0;
    filter: alpha(opacity=0);
}

.centrediv {
    text-align: center;
    padding-top: 15px;
}
</style>
